/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-nested-ternary */
import { Stack } from "@mui/material";
import * as Yup from "yup";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import MDInput from "components/MDInput";
import { currencyFormat } from "utils/HelperFunctions";
// import AddComment from "./AddComment";
import Comments from "./Comments";
import CustomizedSlider from "./CustomizedSlider";
import ReportActionWrapper from "./ReportActionWrapper";
import ScrollToFieldError from "./ScrollToFieldError";

function ReviewReport({
  questions,
  report,
  handleReportAccept,
  // updateQuestionComment,
  // updateReportComment,
}) {
  const [intitalValues, setInitialValues] = useState();
  const [validationSchema, setValidationSchema] = useState();

  useEffect(() => {
    const commentsObject = {
      reportComment: "",
    };
    const validationObject = {};
    questions.forEach((question) => {
      commentsObject[`index_${question.id}`] = "";
      validationObject.reportComment = Yup.string("").max(
        500,
        "Maximum 500 characters are allowed"
      );
      validationObject[`index_${question.id}`] = Yup.string("").max(
        500,
        "Maximum 500 characters are allowed"
      );
    });
    setInitialValues(commentsObject);
    setValidationSchema(Yup.object().shape({ ...validationObject }));
  }, [questions]);

  const generateQuestionJSX = (index, question) => (
    <>
      <MDBox>
        <MDTypography sx={{ fontWeight: 600 }}>
          <MDBox component="span" sx={{ fontWeight: "bold", mr: 1, width: "20px" }}>
            {`${index + 1}.`}
          </MDBox>

          {question.question}
        </MDTypography>
      </MDBox>
      <MDBox>
        <MDTypography>
          {question.type === "currency" ? (
            currencyFormat(question.answer)
          ) : question.type === "self-assessment" ? (
            <CustomizedSlider disabled value={question.answer} />
          ) : question.type === "true/false" ? (
            question.answer ? (
              "Yes"
            ) : (
              "No"
            )
          ) : (
            question.answer
          )}
        </MDTypography>
      </MDBox>
    </>
  );

  const generatePipelineQuestionJSX = (index, question) => (
    <>
      <MDBox>
        <MDTypography sx={{ fontWeight: 600 }}>
          <MDBox component="span" sx={{ fontWeight: "bold", mr: 1, width: "20px" }}>
            {`${index + 1}.`}
          </MDBox>
          Pipeline Health
        </MDTypography>
      </MDBox>
      <Stack direction="row">
        <Stack spacing={1}>
          <Stack>
            <MDTypography>
              {question.question}:
              <MDBox component="span" sx={{ ml: 1, width: "20px" }}>
                {question.answer}
              </MDBox>
            </MDTypography>
          </Stack>
          <Stack>
            <MDTypography>
              {question.childQuestion}:
              <MDBox component="span" sx={{ ml: 1, width: "20px" }}>
                {question.childQuestionAnswer}
              </MDBox>
            </MDTypography>
          </Stack>
          <Stack>
            <Stack>
              <MDTypography>
                Coverage:
                <MDBox component="span" sx={{ ml: 1, width: "20px" }}>
                  {question?.answer && question?.childQuestionAnswer
                    ? `${(question?.answer / question?.childQuestionAnswer).toFixed(2)} X`
                    : ""}
                </MDBox>
              </MDTypography>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </>
  );

  // const handleAddComment = (data, questionId) => {
  //   updateQuestionComment(data, questionId);
  // };

  // const handleReportCommentAdd = (data) => {
  //   updateReportComment(data);
  // };

  return (
    <ReportActionWrapper reportData={report}>
      <Formik
        enableReinitialize
        initialValues={intitalValues}
        validationSchema={validationSchema}
        validateOnChange
        onSubmit={handleReportAccept}
      >
        {({ values, setFieldValue, touched, errors }) => (
          <Form>
            <ScrollToFieldError />
            <Stack
              spacing={2}
              mt={2}
              p="2 0"
              sx={{
                "& .MuiTypography-root": {
                  fontSize: "16px",
                },
                "& .MuiFormHelperText-root": { color: "#d32f2f" },
              }}
            >
              {questions.map((question, index) => (
                <Stack key={question.id} sx={{ p: 2 }}>
                  {question.type !== "pipeline health"
                    ? generateQuestionJSX(index, question)
                    : generatePipelineQuestionJSX(index, question)}

                  {question?.comments?.length > 0 && <Comments comments={question.comments} />}
                  {report.statusId !== "Close" && (
                    <Stack mt={2}>
                      <Stack>
                        <MDTypography>Add Comment:</MDTypography>
                        <MDInput
                          id={`index_${question.id}`}
                          name={`index_${question.id}`}
                          value={values?.[`index_${question.id}`]}
                          onChange={(event) => {
                            setFieldValue(`index_${question.id}`, event.target.value);
                          }}
                          sx={{ background: "#fff", borderRadius: "0.375rem", width: "100%" }}
                          multiline
                          rows={3}
                          cols={3}
                          helperText={
                            touched?.[`index_${question.id}`] && errors?.[`index_${question.id}`]
                          }
                          error={
                            touched?.[`index_${question.id}`] &&
                            Boolean(errors?.[`index_${question.id}`])
                          }
                        />
                      </Stack>
                      {/* <AddComment
                        question={question}
                        reportId={report?.id}
                        index={index}
                        handleCommentAdd={handleAddComment}
                      /> */}
                    </Stack>
                  )}
                </Stack>
              ))}
            </Stack>
            <Stack>
              <Stack
                mt={2}
                px={0}
                sx={{
                  "& .MuiFormHelperText-root": { color: "#d32f2f" },
                }}
              >
                {report.statusId !== "Close" && (
                  <MDTypography sx={{ fontSize: "20px !important", fontWeight: "600", px: 2 }}>
                    Overall Report Comments
                  </MDTypography>
                )}
                {report.statusId !== "Open" && (
                  <MDBox
                    sx={{
                      "& .MuiTypography-root": {
                        fontSize: "16px",
                      },
                      px: 2,
                      pt: report?.CoachupReportComments?.length > 0 && 2,
                    }}
                  >
                    {report?.CoachupReportComments?.length > 0 && (
                      <Comments comments={report?.CoachupReportComments} />
                    )}
                  </MDBox>
                )}
                {report.statusId !== "Close" && (
                  <MDInput
                    fullWidth
                    name="reportComment"
                    value={values?.reportComment}
                    onChange={(event) => {
                      setFieldValue("reportComment", event.target.value);
                    }}
                    sx={{
                      background: "#fff",
                      borderRadius: "0.375rem",
                      width: "100%",
                      mb: 2,
                      p: 2,
                    }}
                    multiline
                    rows={3}
                    cols={3}
                    helperText={touched?.reportComment && errors?.reportComment}
                    error={touched?.reportComment && Boolean(errors?.reportComment)}
                  />
                )}
                {/* <Comments comments={} /> */}
              </Stack>
            </Stack>

            {report.statusId !== "Close" && (
              <MDBox sx={{ display: "flex", justifyContent: "flex-end" }}>
                <MDButton
                  variant="gradient"
                  color="newColor"
                  size="small"
                  type="submit"
                  sx={{ mr: 2 }}
                >
                  Accept
                </MDButton>
              </MDBox>
            )}
          </Form>
        )}
      </Formik>
    </ReportActionWrapper>
  );
}

export default ReviewReport;
